import React, { useState } from "react";
import { Box, Paper, Tabs, Tab, Typography } from "@mui/material";
import InvoiceProduct from "./InvoiceProduct";
import InvoicePayments from "./InvoicePayments";
import InvoiceRetention from "./InvoiceRetention";

const InvoiceDetail = ({ doc }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_e, newValue) => {
    setTabValue(newValue);
  };

  if (!doc) {
    return (
      <Box sx={{ mx: "auto", mt: 3 }}>
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>Cargando detalle…</Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ mx: "auto", mt: 3 }}>
      <Paper
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            backgroundColor: "#1565C0",
            "& .MuiTab-root": {
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              minHeight: "48px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              transition: "all 0.2s ease",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#1565C0",
              borderTop: "4px solid #1565C0",
              borderLeft: "4px solid #1565C0",
              borderRight: "4px solid #1565C0",
              borderBottom: "none",
              marginTop: "5px",
              marginLeft: "10px",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab label="Productos" />
          <Tab label="Retenciones" />
          <Tab label="Formas de Pago" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tabValue === 0 && <InvoiceProduct doc={doc} />}
          {tabValue === 1 && <InvoiceRetention doc={doc} />}
          {tabValue === 2 && <InvoicePayments doc={doc} />}
        </Box>
      </Paper>
    </Box>
  );
};

export default InvoiceDetail;
